import { FormlyFieldConfig, FormlyConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class FormlyValidationLoader
{
    constructor(
        private translate: TranslateService,
        private formlyConfig: FormlyConfig
    ) { }

    /**
     * Initialize the formly validation messages.
     */
    public loadLocalizations(): void
    {
        // Message without params
        this.formlyConfig.addValidatorMessage('required', () => this.translate.instant('VALIDATIONS-REQUIRED'));
        this.formlyConfig.addValidatorMessage('email', () => this.translate.instant('WRONG-EMAIL-FORMAT'));

        // Message with params
        this.formlyConfig.addValidatorMessage('minLength', (err, field) => this.minlengthValidationMessage(err, field, this.translate));
        this.formlyConfig.addValidatorMessage('maxLength', (err, field) => this.maxlengthValidationMessage(err, field, this.translate));
        this.formlyConfig.addValidatorMessage('min', (err, field) => this.minValidationMessage(err, field, this.translate));
        this.formlyConfig.addValidatorMessage('max', (err, field) => this.maxValidationMessage(err, field, this.translate));
    }

    private minlengthValidationMessage(err: any, field: FormlyFieldConfig, translate: TranslateService)
    {
        return translate.instant('VALIDATIONS-MINLENGTH', { value: field.templateOptions.minLength });
    }

    private maxlengthValidationMessage(err: any, field: FormlyFieldConfig, translate: TranslateService)
    {
        return translate.instant('VALIDATIONS-MAXLENGTH', { value: field.templateOptions.maxLength });
    }

    private minValidationMessage(err: any, field: FormlyFieldConfig, translate: TranslateService)
    {
        return translate.instant('VALIDATIONS-MIN', { value: field.templateOptions.min });
    }

    private maxValidationMessage(err: any, field: FormlyFieldConfig, translate: TranslateService)
    {
        return translate.instant('VALIDATIONS-MAX', { value: field.templateOptions.max });
    }
}
